// @flow
export const createAPIEndpoints = ({ JSON }: Object): Object => ({
	fetch: () => JSON.get('squads.json'),
});

export default createAPIEndpoints;


// WEBPACK FOOTER //
// ./src/utils/api/squads/index.js